import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// AUTH APIS (FormData-based)
// Controller: Authapis.php
// ================================

// 1) LOGIN
export async function loginApi(user_email, user_password,influencer_id) {
  try {
    const fd = new FormData();
    fd.append("user_email", user_email);
    fd.append("user_password", user_password);
    fd.append("influencer_id", influencer_id);

    const res = await axios.post(`${apiBaseUrl}authapis/login`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Login Request Failed" };
  }
}

export async function submitRecoveryApi(payload) {
  try {
    const fd = new FormData();

    fd.append("user_id", payload.user_id);
    fd.append("creator_name", payload.creator_name);
    fd.append("old_handle", payload.old_handle);
    fd.append("platform", payload.platform);
    fd.append("reason", payload.reason);
    fd.append("new_platform", payload.new_platform);
    fd.append("new_handle", payload.new_handle);
    fd.append("new_profile_link", payload.new_profile_link);
    fd.append("message", payload.message);
    fd.append("proof_link", payload.proof_link);
    fd.append("old_account_link", payload.old_account_link);

    const res = await axios.post(
      `${apiBaseUrl}authapis/submitRecovery`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch (err) {
    return {
      status: false,
      type: "danger",
      success: "Recovery Request Failed"
    };
  }
}

// 2) SIGNUP
export async function signupApi(payload) {
  try {
    const fd = new FormData();

    fd.append("user_id", payload.user_id || "");
    fd.append("user_name", payload.user_name || "");
    fd.append("user_email", payload.user_email || "");
    fd.append("user_password", payload.user_password || "");
    fd.append("user_type", payload.user_type || "");
    fd.append("agency_name", payload.agency_name || "");
    fd.append("agency_company", payload.agency_company || "");
    fd.append("user_mobile", payload.user_mobile || "");
    fd.append("agency_website", payload.agency_website || "");
    fd.append("inf_platform", payload.inf_platform || "");
    fd.append("inf_category", payload.inf_category || "");
    fd.append("inf_followers", payload.inf_followers || "");
    fd.append("inf_username", payload.inf_username || "");

    
    const res = await axios.post(`${apiBaseUrl}authapis/signup`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Signup Request Failed" };
  }
}

// 3) FORGOT PASSWORD
export async function forgotPasswordApi(user_email) {
  try {
    const fd = new FormData();
    fd.append("user_email", user_email);

    const res = await axios.post(`${apiBaseUrl}authapis/forgot_password`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Reset Request Failed" };
  }
}

// 4) UPGRADE PLAN (optional helper)
export async function upgradePlanApi(umem_user, umem_plan) {
  try {
    const fd = new FormData();
    fd.append("umem_user", umem_user);
    fd.append("umem_plan", umem_plan);

    const res = await axios.post(`${apiBaseUrl}authapis/upgrade_plan`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Upgrade Failed" };
  }
}

export async function chkPlanApi(umem_user) {
  try {
    const fd = new FormData();
    fd.append("umem_user", umem_user);
    
    const res = await axios.post(`${apiBaseUrl}authapis/chk_plan`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Upgrade Failed" };
  }
}

export async function changePasswordApi(payload) {
  try {
    const fd = new FormData();

    fd.append("user_id", payload.user_id);
    fd.append("old_password", payload.current_password);
    fd.append("new_password", payload.new_password);

    const res = await axios.post(
      `${apiBaseUrl}authapis/change_password`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;
  } catch {
    return { status: false };
  }
}

export async function sendOtpNow(email,name) {
  try {
    const fd = new FormData();

    fd.append("email", email);
    fd.append("name", name);

    const res = await axios.post(
      `${apiBaseUrl}authapis/send_otp`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;
  } catch {
    return { status: false };
  }
}

export async function deactivateAccountApi(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await axios.post(
      `${apiBaseUrl}authapis/deactivate_account`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;
  } catch {
    return { status: false };
  }
}
